











































import { Component, Prop, Vue } from 'vue-property-decorator'
import { emptyObject } from '@/utils'

@Component
export default class EditRepetitionDialog extends Vue {
  @Prop({ default: emptyObject }) repetition!: any
  @Prop({ default: false }) visible!: boolean

  onCancelClicked () {
    this.$emit('cancel')
  }

  onSaveClicked () {
    this.$emit('save')
  }
}
